import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import jQuery from 'jquery'

// router setup
import router from './routes/router';
// plugin setup
Vue.use(DashboardPlugin);

Vue.mixin({
  data() {
    return {
      methodEnums:{
        0:"GET",
        1:"POST",
        2:"PUT",
        3:"PATCH",
        4:"DELETE",
        5:"OPTIONS",
        6:"HEAD"
      },
      jobLogStatusDescriptions:{
        0:'Initialized',
        1:'Running',
        2:'Completed',
        3:'Interrupted',
        4:'Failed',
      },
      operationLogStatusDescriptions:{
        0:'Initialized',
        1:'Running',
        2:'Completed',
        3:'Interrupted',
        4:'Failed',
      },
      logLevelDescriptions:{
        0:'NOTSET',
        10:'DEBUG',
        20:'INFO',
        30:'WARNING',
        40:'ERROR',
        50:'CRITICAL',
      },
      weekdays:{
        1:'MON',
        2:'TUE',
        3:'WED',
        4:'THU',
        5:'FRI',
        6:'SAT',
        7:'SUN',
      },
      popularitySiteTypes:{
        0:'Mall',
        1:'MRT/LRT',
        2:'Cold Storage',
        3:'POI',
      },
      locationReportOperationMethodEnums:{
        0:'Geocode',
        1:'Geohash',
        2:'Site code',
        3:'Create report',
        4:'Complete report creation',
      },
    }
  },
  methods:{
    timestampToDatetime(timestamp){
      return new Date(timestamp*1000).toString();
    },
    datetimeToTimestamp(date){
      return new Date(date).getTime()/1000;
    },
    formatDefaultDate(date){
      var addZeroIfSingleDigit = (num) => ('0' + num).slice(-2);
      if(typeof date==='string')
        date=new Date(date)
      
      date = `${addZeroIfSingleDigit(date.getDate())}/${addZeroIfSingleDigit(date.getMonth()+1)}/${date.getFullYear()} ${addZeroIfSingleDigit(date.getHours())}:${addZeroIfSingleDigit(date.getMinutes())}:${addZeroIfSingleDigit(date.getSeconds())}`;
      return date;
    },
    formatDefaultDateTable(row, col, value, index){
      return value === null ? '' : this.formatDefaultDate(value);
    },
    calculateElapsedTime(startTimestamp,endTimestamp){
      var addZeroIfSingleDigit = (num) => ('0' + num).slice(-2);

      if(endTimestamp===null || startTimestamp===null)
        return null

      if(typeof startTimestamp==='string')
        startTimestamp=this.datetimeToTimestamp(startTimestamp);
      
      if(typeof endTimestamp==='string')
        endTimestamp=this.datetimeToTimestamp(endTimestamp);

      var timeElapsed=endTimestamp-startTimestamp;
      var hours=addZeroIfSingleDigit(Math.floor(timeElapsed/3600));
      var minutes=addZeroIfSingleDigit(Math.floor(timeElapsed/60)%60);
      var seconds=addZeroIfSingleDigit(timeElapsed%60);

      return `${hours}:${minutes}:${seconds}`
    },
    capitalize(str){
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    copyObject(obj){
      return JSON.parse(JSON.stringify(obj))
    },
    downloadExcelBlob(response,filename){
      const blob = new Blob([response.data])//, { type: "application/xlsx" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    randomRGB(){
      var random = () => Math.floor(Math.random() * 256)
      return `rgb(${random()},${random()},${random()})`
    }
  }
})

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});
